import { useResponsivenessScoreEnabled } from '../../../layout/hooks/useResponsivenessScoreEnabled';

import { AvatarAndBadge } from './components/AvatarAndBadge';
import { Description } from './components/Description';
import { DmStats } from './components/DmStats';
import { NameAndTitle } from './components/NameAndTitle';
import { ResponsivenessScore } from './components/ResponsivenessScore';
import { useProfileCardViewTracker } from './hooks/useProfileCardTracker';

export function ProfileCard() {
	useProfileCardViewTracker();

	const responsivenessScoreEnabled = useResponsivenessScoreEnabled();

	return (
		<>
			<div className="mb-8">
				<div
					className="mb-6 flex flex-col items-center justify-between gap-6 lg:flex-row lg:items-start"
					data-qa="dm-header"
				>
					<div className="absolute top-[59px] h-[105px] w-full lg:hidden">
						<div className="relative h-full w-full">
							<div className="bg-surface-neutral h-full w-full"></div>
							<div className="absolute bottom-[-50px] h-[100px] w-full rounded-tl-[100%] rounded-tr-[100%] bg-white"></div>
						</div>
					</div>
					<div className="items-center gap-6 lg:flex">
						<AvatarAndBadge />
						<div className="mt-6">
							<NameAndTitle />
						</div>
					</div>
					{responsivenessScoreEnabled && <ResponsivenessScore />}
				</div>

				<Description />
			</div>
			<DmStats />
		</>
	);
}
